// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._zulp1b66{gap:var(--ds-space-050,4px)}._195gu2gc{margin-inline:var(--ds-space-100,8px)}\n._1bsbt94y{width:1px}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}\n._4t3igktf{height:20px}\n._bfhkmuej{background-color:var(--ds-border,#091e4224)}", ""]);
// Exports
module.exports = exports;
